import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API from '../../api';
import MessageModal from '../smallComponent/MessageModal';

export default function CustomerEdit() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState({
    customer_name: '',
    contact_number: '',
    business_name: '',
    address: '',
    work_details: '',
    source: ''
  });

  const [modal, setModal] = useState({
    show: false,
    message: '',
    title: '',
    type: 'info',
    redirectPath: null,
  });

  useEffect(() => {
    fetchCustomer();
  }, []);

  const fetchCustomer = async () => {
    try {
      const token = localStorage.getItem('token');
      const res = await API.get(`/customers/${id}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setCustomer(res.data);
    } catch (error) {
      console.error(error);
      setModal({
        show: true,
        message: "❌ Failed to fetch customer",
        title: "Error",
        type: "error",
        redirectPath: null,
      });
    }
  };

  const handleChange = (e) => {
    setCustomer({ ...customer, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const token = localStorage.getItem('token');
      await API.put(`/customers/${id}/beforeDone`, customer, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setModal({
        show: true,
        message: "✅ Customer updated successfully",
        title: "Success",
        type: "success",
        redirectPath: '/dashboard/followup-list'
      });
    } catch (error) {
      console.error("Update failed:", error.response || error);
      setModal({
        show: true,
        message: "❌ Failed to update customer",
        title: "Error",
        type: "error",
        redirectPath: null,
      });
    }
  };

  const handleCloseModal = () => {
    setModal(prev => ({ ...prev, show: false }));
    if (modal.redirectPath) {
      setTimeout(() => {
        navigate(modal.redirectPath);
      }, 500);
    }
  };

  return (
    <div className="max-w-4xl mx-auto mt-10 px-4">
      <div className="bg-white shadow-lg rounded-xl p-6">
        <h2 className="text-xl font-semibold text-blue-600 mb-4">✏️ Edit Customer</h2>
        <form onSubmit={handleSubmit} className="space-y-5">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block font-medium mb-1">Customer Name</label>
              <input
                name="customer_name"
                value={customer.customer_name}
                onChange={handleChange}
                required
                placeholder="Enter customer name"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-400"
              />
            </div>
            <div>
              <label className="block font-medium mb-1">Contact Number</label>
              <input
                name="contact_number"
                value={customer.contact_number}
                onChange={handleChange}
                required
                placeholder="Enter phone number"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-400"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block font-medium mb-1">Business Name</label>
              <input
                name="business_name"
                value={customer.business_name}
                onChange={handleChange}
                placeholder="Enter business name"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-400"
              />
            </div>
            <div>
              <label className="block font-medium mb-1">Source</label>
              <input
                name="source"
                value={customer.source}
                onChange={handleChange}
                placeholder="e.g. Facebook, Website, Referral"
                className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-400"
              />
            </div>
          </div>

          <div>
            <label className="block font-medium mb-1">Address</label>
            <input
              name="address"
              value={customer.address}
              onChange={handleChange}
              placeholder="Enter full address"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-400"
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Work Details</label>
            <textarea
              rows={3}
              name="work_details"
              value={customer.work_details}
              onChange={handleChange}
              placeholder="Enter work-related discussion or request"
              className="w-full border border-gray-300 rounded-lg px-4 py-2 focus:ring focus:ring-blue-400"
            />
          </div>

          <div className="text-right">
            <button
              type="submit"
              className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition duration-200"
            >
              💾 Update
            </button>
          </div>
        </form>
      </div>

      {/* ✅ Common Message Modal */}
      <MessageModal
        show={modal.show}
        onClose={handleCloseModal}
        title={modal.title}
        message={modal.message}
        type={modal.type}
      />
    </div>
  );
}
